
/// <reference path="../../../setup/_references.ts" />
module onvio.clientDashboard.ClientRelatedContactsComponent {
    'use strict';

    export interface IRelatedContacts {
        contactsSummary: cs.IPagedItemsDto<cs.IContactWithExpansionV7Dto>;
        relationships: cs.IPagedItemsDto<cs.IContactRelationshipViewV1Dto>;
    }

    export class ClientRelatedContactsController implements IRelatedContacts {
        public preferred: cs.IContactWithExpansionV7Dto;
        public taxMatters: cs.IContactWithExpansionV7Dto;
        public billing: cs.IContactWithExpansionV7Dto;
        public spouse: cs.IContactWithExpansionV7Dto;
        public isLoading: boolean;
        public client: cs.IClientWithExpansionV3Dto;
        public onEdit: (contact: cs.IContactWithExpansionV7Dto) => void;
        public viewContacts: (client: cs.IClientWithExpansionV3Dto) => void;
        contactsSummary: cs.IPagedItemsDto<cs.IContactWithExpansionV7Dto>;
        relationships: cs.IPagedItemsDto<cs.IContactRelationshipViewV1Dto>;

        static $inject = [
            '$translate',
            'csContactRelationshipViewV1',
            'csContactV7',
            'bmpModalService'
        ];
        constructor(
            private $translate: ng.translate.ITranslateService,
            private contactRelationshipViewV4Service: cs.IContactRelationshipV4Service,
            private contactV7Service: cs.IContactV7Service,
            private bmpModalService: bmp.ModalHelper.BmpModalService
        ) { }

        $onChanges(changes: any) {
            if (changes.client && changes.client.currentValue && changes.client.currentValue.id) {
                this.loadClientRelatedContactsData();
            }
        }

        public getNoRelatedContactsString(): string {
            if (this.client) {
                return this.$translate.instant('Onvio.ClientDashboard.RelatedContacts.NoRelatedContacts', {
                    clientName: this.client.primaryContactExpanded.displayAs
                });
            }
            return '';
        }

        private loadClientRelatedContactsData() {
            this.isLoading = true;
            this.contactsSummary = null;
            this.relationships = null;
            var params: any = {
                filterSearchSort: {
                    filter: new bmp.Filter().where('relationshipSide.code').isInList(['BILLINGCONTACT_B', 'PREFERREDCONTACT_B', 'TAXMATTERSCONTACT_B', 'MARRIAGE_B', 'MARRIAGE_A']).toString(),
                    orderBy: 'contact.id asc',
                },
                expand: 'relationshipSide.name,relationshipSide.code,relationshipSide.id,contact.id,contact.displayAs'
            };
            let getListPromise = this.contactRelationshipViewV4Service.postSearch({ contactId :this.client.primaryContact.id, postData: params });
            getListPromise.then((pagedItems: cs.IPagedItemsDto<cs.IContactRelationshipViewV1Dto>) => {
                this.relationships = pagedItems;
                let contactIds: any[] = [];

                for (let index = 0; index < pagedItems.items.length; index++) {
                    contactIds.push(pagedItems.items[index].contact.id);
                }

                if (contactIds.length > 0) {
                    this.contactV7Service.getClientRelatedContacts({
                        contactId: this.client.primaryContact.id,
                        expand: 'contactImageExpanded'
                    }).then((contacts: cs.IPagedItemsDto<cs.IContactWithExpansionV7Dto>) => {
                        let receivedContacts = contacts.items;
                        this.contactsSummary = contacts;
                        this.contactsSummary.items = [];
                        //searching pairs of contact and relationship to be able to display all relationships
                        //even if one contact is assigned to multiple relationships
                        for (let relationIndex = 0; relationIndex < this.relationships.items.length; relationIndex++) {
                            for (let contactIndex = 0; contactIndex < receivedContacts.length; contactIndex++) {
                                if (receivedContacts[contactIndex].id === this.relationships.items[relationIndex].contact.id) {
                                    this.contactsSummary.items.push({
                                        ...receivedContacts[contactIndex],
                                        $relationshipSide: this.relationships.items[relationIndex].relationshipSide
                                    });
                                    break;
                                }
                            }
                        }
                        this.isLoading = false;
                    });

                } else {
                    this.isLoading = false;
                }
            });
        }

        public edit(model: cs.IContactWithExpansionV7Dto, type: bmp.ModalHelper.AotfEntityName) {
            let onModalClose = () => {
                this.loadClientRelatedContactsData();
            };

            let onModalDismiss = () => {
                angular.noop();
            };

            let params: bmp.ModalHelper.IAotfParams = {
                entityName: type
            };

            this.bmpModalService.editOnTheFly(model.id, params, onModalClose, onModalDismiss);
        }

        public contactType(relationshipName: string): string {
            switch (relationshipName) {
                case 'BILLINGCONTACT_B':
                    return 'billing';
                case 'TAXMATTERSCONTACT_B':
                    return 'taxMatters';
                case 'PREFERREDCONTACT_B':
                    return 'preferred';
                case 'MARRIAGE_B':
                    return 'spouse';
                default:
                    return '';
            }
        }
    }

    export class ClientRelatedContactsComponent implements ng.IComponentOptions {
        bindings: any = {
            client: '<',
            viewContacts: '&',
        };
        controller = ClientRelatedContactsController;
        templateUrl = 'client-dashboard/components/client-related-contacts-component/client-related-contacts-component.html';
    }

    angular.module('onvio.clientDashboard.ClientRelatedContactsComponent', ['bento.modern', 'bento.d3', 'tmh.dynamicLocale'])
        .component('clientRelatedContacts', new ClientRelatedContactsComponent());
}
